import { RootState } from 'store/rootTypes';

export const InvoiceSelector = (state: RootState) => state.Invoice;
